export const GTAG_ID = 'G-VRPMCST53D'